import React, { useContext } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { Duplicate } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { TRACK } from "../../AddToConstants";
import { triggerAnalytics } from "../../AddToHelpers";


export const CopyListTile = ({ }) => {
  const {
    setScreen
  } = useContext(AddToContext);

  const handleTileClick = () => {
    // 7.1 Copy from Your Lists selection - when drawer opens
    triggerAnalytics(TRACK.ADD_TO_LIST_COPY_FROM_LISTS_SELECTION);
    setScreen('COPY_LIST_SUMMARY');
  };
  return (
    <div
      onClick={handleTileClick}
      className='sui-mt-8 sui-cursor-pointer'
    >
      <Card data-testid="copy-list" disablePadding disableGutters orientation="horizontal">
        <div className='sui-w-24 sui-flex sui-justify-center sui-items-center'>
          <Duplicate size='large' />
        </div>
        <div className="sui-py-3 sui-pr-1">
          <CardTitle header="Copy from Your Lists" headerWeight="bold" />
          <CardBody>
            <Typography>Pull in items from one or more of your existing lists.</Typography>
          </CardBody>
        </div>
      </Card>
    </div>
  );
};

CopyListTile.displayName = 'CopyListTile';

CopyListTile.propTypes = {};

CopyListTile.defaultProps = {};

// CopyListTile.dataModel = extend({});

